import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    additionalFormStyle: {
      '& .MuiToolbar-gutters': {
        paddingLeft: theme.spacing(0),
        display: 'none'
      }
    },
    additionalCardHeaderStyle: {
      '& .MuiCardHeader-title': {
        color: theme.palette.primary.main,
        fontSize: '1.0rem',
        fontWeight: 'bold',
        opacity: 0.7
      },
      '& .MuiCardHeader-content': {
        paddingTop: '16px'
      }
    }
  });
